import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from "react-redux";
import { selectMenuByRole } from "../../store/menu-slice";

const SidebarNav = () => {
    const menu = useSelector(state => state.menu.items);
    const { selectedRole } = useSelector((state) => state.auth);

    const userRole = selectedRole
        ? `${selectedRole.scope}${selectedRole.role}`
        : "Customer";

    const filteredMenu = selectMenuByRole(menu, userRole);

    const renderMenu = (items, depth = 0) => {
        const isChild = depth > 0;

        return items
            .map((item, index) => (
                <li className="nav-item" key={item.name + index}>
                    <NavLink
                        to={item.url}
                        className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                        end={depth === 0 && index === 0}
                        style={{ "--bs-nav-link-padding-y": isChild ? "0.3rem" : "0.5rem" }}
                    >
                        <div className={`d-flex justify-content-between${isChild ? " fs-md" : ""}`}>
                            {item.name}
                        </div>
                    </NavLink>

                    {item.children && (
                        <ul className="navbar-nav flex-column ps-3">
                            {renderMenu(item.children, depth + 1)}
                        </ul>
                    )}
                </li>
            ));
    };

    return (
        <div className="navbar w-100 align-items-start">
            <ul className="navbar-nav flex-column w-100">
                {renderMenu(filteredMenu)}
            </ul>
        </div>
    );
};

export default SidebarNav;
